// src/services/hero.ts
import api from "../lib/api";

// ============================================
// TYPE DEFINITIONS
// ============================================

export interface HeroSection {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  buttonText?: string;
  buttonLink?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface HeroSectionInput {
  title: string;
  subtitle: string;
  description: string;
  buttonText?: string;
  buttonLink?: string;
}

// ============================================
// PUBLIC API ENDPOINTS
// ============================================

/**
 * Get active hero section for public display
 */
export async function getHeroSection(): Promise<HeroSection> {
  const { data } = await api.get('/api/hero');
  return data.data.heroSection;
}

// ============================================
// ADMIN API ENDPOINTS
// ============================================

/**
 * Update hero section (admin only)
 */
export async function updateHeroSection(heroData: HeroSectionInput): Promise<HeroSection> {
  const { data } = await api.put('/api/hero', heroData);
  return data.data.heroSection;
}
